import { CHANGE_PASSWORD, REGISTRATION, SEND_CODE, SET_FULLNAME, SET_PASSWORD } from '@plugins/service/api/urls'
import { checkStatus } from '@helper/utils'

export function startLogin ({ dispatch }, { mobile, country_code, auth_origin }) {
  return this.$api.post({
    url: REGISTRATION,
    payload: { auth_origin, mobile, country_code }
  })
}
export function sendCode ({}, { mobile, method = 'SMS', auth_origin }) {
  return this.$api.create({
    url: SEND_CODE,
    payload: { mobile, send_method: method, auth_origin }
  })
}
export function checkCode ({ dispatch }, { mobile, mobile_verification_code, method = 'COOKIE_AND_TOKEN', auth_origin, set_password = false }) {
  return this.$auth.loginWith('loginByVerifyCode', {
    data: {
      auth_origin,
      mobile,
      mobile_verification_code,
      auth_method: method,
      set_password
    }
  })
}
export async function setPassword ({}, { password, password_confirmation }) {
  try {
    const { data, status } = await this.$api.create({
      url: SET_PASSWORD,
      payload: { password, password_confirmation }
    })
    if (checkStatus(status)) {
      return Promise.resolve(data)
    }
  } catch (error) {
    this.$logger.captureException({ error })
    return Promise.reject(error)
  }
}
export async function changePassword ({}, { password, password_confirmation, auth_origin, allow_code }) {
  return await this.$api.create({
    url: CHANGE_PASSWORD,
    payload: { password, password_confirmation, auth_origin, allow_code }
  })
}
export async function setFullname ({}, { auth_origin, fullname }) {
  return await this.$api.create({
    url: SET_FULLNAME,
    payload: { fullname, auth_origin }
  })
}
export function loginPassword ({}, { password, mobile, method = 'COOKIE_AND_TOKEN', auth_origin }) {
  return this.$auth.loginWith('loginByPassword', {
    data: {
      auth_origin,
      auth_method: method,
      password,
      mobile
    }
  })
}
export function logout () {
  try {
    this.$auth.logout('local')
    this.$router.push(this.app.localePath({ name: this.app.$routeName.homeName }))
  } catch (error) {
    this.$logger.captureException({ error })
  }
}
